<script setup>

</script>

<template>
    <table class="table-auto w-full max-w-[50rem] mt-4">
        <thead class="text-left text-lg border-b-2 border-primary">
            <tr class="mx-6">
                <th>Name</th>
                <th class="w-20 sm:w-auto text-right">{{ $t('per hour') }}</th>
                <th class="w-24 sm:w-auto text-right">{{ $t('per month') }}</th>
            </tr>
        </thead>
        <tbody class="text-lg">
            <slot />
        </tbody>
    </table>
</template>
